import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/Images/img-realtor.png'
import _imports_1 from '../../assets/Images/inspector.png'
import _imports_2 from '../../assets/Images/img-title.png'
import _imports_3 from '../../assets/Images/mlo.png'
import _imports_4 from '../../assets/Images/logo-login.png'


const _hoisted_1 = { class: "hidden-mobile" }
const _hoisted_2 = { class: "sign-up" }
const _hoisted_3 = { class: "container-fixed" }
const _hoisted_4 = { class: "sign-up__content d-flex justify-content-between" }
const _hoisted_5 = { class: "w-50" }
const _hoisted_6 = {
  key: 0,
  class: "sign-up__content__imagen p-0 h-100 w-100"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-100 p-0 h-100",
  alt: ""
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "sign-up__content__imagen p-0 h-100 w-100"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-100 p-0 h-100",
  alt: ""
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "sign-up__content__imagen p-0 h-100 w-100"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-100 p-0 h-100",
  alt: ""
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 3,
  class: "sign-up__content__imagen p-0 h-100 w-100"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-100 p-0 h-100",
  alt: ""
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "sign-up__content__formulario pr-0 w-50 d-flex justify-content-center align-items-center" }
const _hoisted_19 = ["onSubmit"]
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"sign-up__content__formulario__img mt-3\"><div class=\"sign-up__content__formulario__img__return text-left\"><a class=\"d-flex align-items-center\" href=\"/\"><i class=\"fas fa-arrow-circle-left\"></i><span> Go back </span></a></div></div><div class=\"tw-flex tw-justify-center\"><img class=\"tw-w-[80px]\" src=\"" + _imports_4 + "\" alt=\"\"></div><div class=\"sign-up__content__formulario__tittle mt-2 mb-2\"><span>Sign Up</span></div>", 3)
const _hoisted_23 = { class: "sign-up__content__formulario__form-register" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "form-group invalid" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-id-card" }, null, -1)
const _hoisted_31 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "form-group invalid" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-volume" }, null, -1)
const _hoisted_38 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" }, null, -1)
const _hoisted_41 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_42 = {
  key: 2,
  class: "form-group"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" }, null, -1)
const _hoisted_44 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_45 = {
  key: 3,
  class: "form-group"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-code" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Select inspection type", -1)
const _hoisted_48 = ["value"]
const _hoisted_49 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag-usa" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "State", -1)
const _hoisted_53 = ["value"]
const _hoisted_54 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "County", -1)
const _hoisted_58 = ["value"]
const _hoisted_59 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-code" }, null, -1)
const _hoisted_62 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_63 = {
  key: 4,
  class: "form-group"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" }, null, -1)
const _hoisted_65 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_66 = { class: "form-group" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa fa-paperclip" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Subsystem Codes", -1)
const _hoisted_69 = ["value"]
const _hoisted_70 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_71 = /*#__PURE__*/_createStaticVNode("<h3 class=\"mt-3\"><b>WHAT IS A SUB-SYSTEM CODE?</b></h3><br><p>The sub-system code enables the creation of an independent operational unit<br> within the RealtorTools platform. This feature is designed for groups of <br> real estate professionals who carry out commercial, financial, or support-related<br> activities tied to the sale of properties, with or without financing.</p><br><br><p>Each sub-system typically functions as an exclusive workspace under the coordination <br> of a Broker, allowing all involved parties such as agents, loan originators, attorneys,<br> inspectors, and title companies to collaborate in a structured environment. <br> Through this integration, Realtors gain access to customized tools, shared metrics,<br> and a streamlined workflow that supports reaching residential clients and investors<br> across the globe.</p><br><br><p>If the Broker you work with has not enabled or does not require a sub-system within <br> RealtorTools, you have the option to request access to one of our pre-enabled <br>sub-systems at: </p><br><br>", 11)
const _hoisted_82 = ["onClick"]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("b", null, "GET YOUR SUB-SYSTEM CODE", -1)
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary mt-3 mb-4",
  style: {"width":"400px"}
}, " REGISTER ", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import axios from 'axios';
import { ref, computed, onMounted } from 'vue';
import UserService from "@/shared/services/user.service";
import { environment } from "@/environment";
import { useRoute, useRouter } from 'vue-router';

//COMPONENTS
import VueNumberFormat from "vue-number-format";

import { useToast } from "@/composables/useToast";

export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterUsersView',
  emits: ['update:propertyState', 'update:propertyCounty', 'update:propertyCodes'],
  setup(__props, { emit }) {

const toast = useToast();
const route = useRoute();
const router = useRouter();
const isOpen = ref(false);
//VARIABLES
const url = environment.URL_API;
const loading = ref(false);
const formSubmitted = ref(false);



const typeUser = Number(route.query.type);

const register = ref({
    id_user: null,
    id_rol: typeUser,
    username: '',
    lastname: '',
    phone_Number: '',
    email: '',
    state: '',
    country: '',
    addressess: '',
    zip_code: '',
    company_Name: '',
    password: '',
    picture: '',
    license_number: '',
    active: 0,
    createDate: null,
    verificationCode: '',
    inspectionType: '',
    brokerName: '',
    code: ''

});
console.log(typeUser);
const isValid = computed(() => {
    return {
        username: typeUser == 5 ? true : !!register.value.username,
        lastname: typeUser == 5 ? true : !!register.value.lastname,
        phone_Number: !!register.value.phone_Number,
        email: !!register.value.email,
        state: !!estate.value,
        country: !!county.value,
        zip_code: !!register.value.zip_code,
        company_Name: typeUser == 5 ? !!register.value.company_Name : true,
        license_number: (typeUser == 1 || typeUser == 2) ? !!register.value.license_number : true,
        inspectionType: typeUser == 3 ? !!register.value.inspectionType : true,
        brokerName: typeUser == 1 ? !!register.value.brokerName : true,
        code: !!code.value,
    }
});
const isFormvalid = computed(() => {
    return Object.values(isValid.value).every(val => val === true);
});
const estate = ref(null)
const county = ref(null)
const code = ref(null)
const listStates = ref([])
const listCounties = ref([])
const listCodes = ref([])
const inspectionTypes = ref([
    {
        id: 0,
        name: "ATTIC"
    },
    {
        id: 1,
        name: "ASBESTOS"
    },
    {
        id: 2,
        name: "ELECTRIC"
    },
    {
        id: 3,
        name: "RADON"
    },
    {
        id: 4,
        name: "ROOF INSPECTION"
    },
    {
        id: 5,
        name: "POINT INSPECTION"
    },
    {
        id: 6,
        name: "FOUNDATION INSPECTION"
    },
    {
        id: 7,
        name: "HVAC"
    },
    {
        id: 8,
        name: "MOLD INSPECTION"
    },
    {
        id: 9,
        name: "POOL INSPECTION"
    },
    {
        id: 10,
        name: "HEATING SYSTEM"
    },
    {
        id: 11,
        name: "LEAD"
    },
    {
        id: 12,
        name: "PLUMBINO"
    },
    {
        id: 13,
        name: "WDO INSPECTION"
    },
    {
        id: 14,
        name: "HOME INSPECTOR"
    }
])
const getCode = (): void => {
    router.push({
        path: '/register/realtorcode',
    })
};

const getStates = async () => {
    loading.value = true;
    try {
        const response = await axios(
            `${url}realtor-format/get-states`,
            {
                method: "GET",
            }
        );
        if (response.data.success) {
            listStates.value = response.data.states;
        } else {
            await toast.error(`Error loading states`, {
                position: "top-end",
                timer: 3000,
                showCloseButton: true,
            });
        }
    } catch (error) {
        await toast.error(`Error loading states`, {
            position: "top-end",
            timer: 3000,
            showCloseButton: true,
        });
        console.error("Error:", error);
    } finally {
        loading.value = false;
    }
};

const getCounties = async () => {
    loading.value = true
    emit('update:propertyState', estate.value)
    let state: any = estate.value;
    const response = (await UserService.getCounty(state)).data

    if (!response.error) {
        let list: any = response.data
        if (list.length > 0) {
            listCounties.value = list.filter((a: any) => a.length > 0);
        };
    }
    else {
        await toast.error(`Error loading countries`, {
            position: "top-end",
            timer: 3000,
            showCloseButton: true,
        });
    }

    loading.value = false
}

const getCodeByCounty = async () => {
    loading.value = true
    emit('update:propertyCounty', county.value)

    try {
        const response = await axios(
            `${url}realtor-format/get-codes?state=${estate.value}&county=${county.value}`,
            {
                method: "GET",
            }
        );
        if (response.data.success) {
            listCodes.value = response.data.codes;
        } else {
            toast.error("Error loading codes", {
                position: "top-end",
                timer: 3000,
                showCloseButton: true,
            });
        }
    } catch (error) {
        toast.error("Error loading codes", {
            position: "top-end",
            timer: 3000,
            showCloseButton: true,
        });
        console.error("Error:", error);
    } finally {
        loading.value = false;
    }
}
const updateProperty = () => {
    emit('update:propertyState', estate.value)
    emit('update:propertyCounty', county.value)
    emit('update:propertyCodes', code.value)
}

const submitUser = async () => {
    loading.value = true;
    if (!isFormvalid.value) {
        await toast.error("Please fill in all required fields", {
            position: "top-end",
            timer: 3000,
            showCloseButton: true,
        });
        return;
    }
    loading.value = true;
    try {
        const response = await axios(`${url}register`, {
            method: "POST",
            data: {
                register: [{
                    id_user: null,
                    id_rol: typeUser,
                    username: register.value.username,
                    lastname: register.value.lastname,
                    phone_Number: register.value.phone_Number,
                    email: register.value.email,
                    state: estate.value,
                    country: county.value,
                    zip_code: register.value.zip_code,
                    company_Name: register.value.company_Name,
                    password: register.value.password,
                    picture: register.value.picture,
                    license_number: register.value.license_number,
                    active: register.value.active,
                    verificationCode: register.value.verificationCode,
                    inspectionType: register.value.inspectionType,
                    brokerName: register.value.brokerName,
                    code: code.value,
                }]
            },
        });

        if (!response.data.error) {
            const userIdResponse = await axios.get(`${url}user-id?`, {
                params: {
                    email: register.value.email
                }
            });

            await toast.success(response.data.message, {
                position: "top-end",
                timer: 3000,
                showCloseButton: true,
            });
            //backend id_user como response
            router.push({
                path: "/register/typePayment",
                query: {
                    type: typeUser,
                    userId: userIdResponse.data.id_user
                }
            });
        } else {
            await toast.error(response.data.message, {
                position: "top-end",
                timer: 8000,
                showCloseButton: true,
            });
        }
    } catch (error) {
        console.error("error al registrar usuario: ", error);
        await toast.error("Error during registration. Please try again.", {
            position: "top-end",
            timer: 3000,
            showCloseButton: true,
        });
    } finally {
        loading.value = false;
    }
}
getStates()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_unref(typeUser) == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
              : _createCommentVNode("", true),
            (_unref(typeUser) == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            (_unref(typeUser) == 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
              : _createCommentVNode("", true),
            (_unref(typeUser) == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("form", {
              class: "w-50",
              onSubmit: _withModifiers(submitUser, ["prevent"])
            }, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  (_unref(typeUser) != 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "Name",
                            id: "username",
                            class: _normalizeClass(["form-control", { 'invalid': !isValid.value.username && formSubmitted.value }]),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((register.value.username) = $event))
                          }, null, 2), [
                            [_vModelText, register.value.username]
                          ]),
                          (!isValid.value.username && formSubmitted.value)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_28, " Name is required"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "Last Name",
                            id: "lastname",
                            class: _normalizeClass(["form-control", { 'invalid': !isValid.value.lastname && formSubmitted.value }]),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((register.value.lastname) = $event))
                          }, null, 2), [
                            [_vModelText, register.value.lastname]
                          ]),
                          (!isValid.value.lastname && formSubmitted.value)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_31, " Last name is required"))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(typeUser) == 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "Company Name",
                            id: "companyname",
                            class: _normalizeClass(["form-control", { 'invalid': !isValid.value.company_Name && formSubmitted.value }]),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((register.value.company_Name) = $event))
                          }, null, 2), [
                            [_vModelText, register.value.company_Name]
                          ]),
                          (!isValid.value.company_Name && formSubmitted.value)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_35, "Company name is required"))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      placeholder: "Phone Number",
                      id: "phone_number",
                      class: _normalizeClass(["form-control", { 'invalid': !isValid.value.phone_Number && formSubmitted.value }]),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((register.value.phone_Number) = $event))
                    }, null, 2), [
                      [_vModelText, register.value.phone_Number]
                    ]),
                    (!isValid.value.phone_Number && formSubmitted.value)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_38, " Phone number is required"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      placeholder: "Email",
                      id: "email",
                      class: _normalizeClass(["form-control", { 'invalid': !isValid.value.email && formSubmitted.value }]),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((register.value.email) = $event))
                    }, null, 2), [
                      [_vModelText, register.value.email]
                    ]),
                    (!isValid.value.email && formSubmitted.value)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_41, " Email is required"))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(typeUser) == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _hoisted_43,
                        _withDirectives(_createElementVNode("input", {
                          type: "brokerName",
                          placeholder: "Realtor Estate Broker's Name",
                          id: "brokerName",
                          class: _normalizeClass(["form-control", { 'invalid': !isValid.value.brokerName && formSubmitted.value }]),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((register.value.brokerName) = $event))
                        }, null, 2), [
                          [_vModelText, register.value.brokerName]
                        ]),
                        (!isValid.value.brokerName && formSubmitted.value)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_44, " Broker Name is required"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(typeUser) == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _hoisted_46,
                        _withDirectives(_createElementVNode("select", {
                          type: "text",
                          placeholder: "Inspection Type",
                          id: "inspectiontype",
                          class: _normalizeClass(["form-control", { 'invalid': !isValid.value.inspectionType && formSubmitted.value }]),
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((register.value.inspectionType) = $event))
                        }, [
                          _hoisted_47,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inspectionTypes.value, (t, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: t.name,
                              key: index
                            }, _toDisplayString(t.name), 9, _hoisted_48))
                          }), 128))
                        ], 2), [
                          [_vModelSelect, register.value.inspectionType]
                        ]),
                        (!isValid.value.inspectionType && formSubmitted.value)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_49, " Inspection type is required"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _withDirectives(_createElementVNode("select", {
                      name: "",
                      id: "",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((estate).value = $event)),
                      class: _normalizeClass(["form-control", { 'invalid': !isValid.value.state && formSubmitted.value }]),
                      onChange: _cache[8] || (_cache[8] = ($event: any) => (getCounties()))
                    }, [
                      _hoisted_52,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listStates.value, (state) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: state.state
                        }, _toDisplayString(state.state), 9, _hoisted_53))
                      }), 256))
                    ], 34), [
                      [_vModelSelect, estate.value]
                    ]),
                    (!isValid.value.state && formSubmitted.value)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_54, " State is required"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _withDirectives(_createElementVNode("select", {
                      name: "",
                      id: "",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((county).value = $event)),
                      class: _normalizeClass(["form-control", { 'invalid': !isValid.value.county && formSubmitted.value }]),
                      onChange: _cache[10] || (_cache[10] = ($event: any) => (getCodeByCounty()))
                    }, [
                      _hoisted_57,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listCounties.value, (country) => {
                        return (_openBlock(), _createElementBlock("option", { value: country }, _toDisplayString(country), 9, _hoisted_58))
                      }), 256))
                    ], 34), [
                      [_vModelSelect, county.value]
                    ]),
                    (!isValid.value.county && formSubmitted.value)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_59, " County is required"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Zip Code",
                      id: "zipcode",
                      class: _normalizeClass(["form-control", { 'invalid': !isValid.value.zip_code && formSubmitted.value }]),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((register.value.zip_code) = $event))
                    }, null, 2), [
                      [_vModelText, register.value.zip_code]
                    ]),
                    (!isValid.value.zip_code && formSubmitted.value)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_62, " Zip code is required"))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(typeUser) == 1 || _unref(typeUser) == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _hoisted_64,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "License Number",
                          id: "licensenumber",
                          class: _normalizeClass(["form-control", { 'invalid': !isValid.value.license_number && formSubmitted.value }]),
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((register.value.license_number) = $event)),
                          maxlength: "7"
                        }, null, 2), [
                          [_vModelText, register.value.license_number]
                        ]),
                        (!isValid.value.license_number && formSubmitted.value)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_65, " License number is required"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _withDirectives(_createElementVNode("select", {
                      name: "",
                      id: "",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((code).value = $event)),
                      class: _normalizeClass(["form-control", { 'invalid': !isValid.value.code && formSubmitted.value }])
                    }, [
                      _hoisted_68,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listCodes.value, (code) => {
                        return (_openBlock(), _createElementBlock("option", { value: code }, _toDisplayString(code), 9, _hoisted_69))
                      }), 256))
                    ], 2), [
                      [_vModelSelect, code.value]
                    ]),
                    (!isValid.value.code && formSubmitted.value)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_70, " Subsystem Codes required"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      class: "golden-button",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (isOpen.value = true)),
                      style: {"cursor":"pointer"}
                    }, "WHAT IS A SUB-SYSTEM CODE?"),
                    (isOpen.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "modal-overlay",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (isOpen.value = false))
                        }, [
                          _createElementVNode("div", {
                            class: "modal-content-subsystem",
                            onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("span", {
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (isOpen.value = false)),
                              class: "close-subsystem"
                            }, "✕"),
                            _hoisted_71,
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(getCode, ["prevent"]),
                              class: "btn btn-primary",
                              style: {"width":"300px"}
                            }, _hoisted_84, 8, _hoisted_82)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_85,
                  _hoisted_86
                ])
              ])
            ], 40, _hoisted_19)
          ])
        ])
      ])
    ])
  ]))
}
}

})